import {
    Chart as ChartJS,
    PointElement,
    LineElement,
    ArcElement,
    BarElement,
    Tooltip,
    Legend,
    CategoryScale,
    LinearScale,
    Title,
} from "chart.js";

export const registerCharts = () => {
    ChartJS.register(
        CategoryScale,
        LinearScale,
        BarElement,
        LineElement,
        PointElement,
        Title,
        ArcElement,
        Tooltip,
        Legend
    );
};